import type { AreaCatalog } from '../area';
import type { attributes as en } from '../en/attributes';

export const attributes = {
  'attributes.name.active': 'Aktivität',
  'attributes.name.closed': 'Abschluss',
  'attributes.name.delivered': 'Fertigstellung',
  'attributes.name.verdict': 'Bewertung',
  'attributes.value.active.no': 'Ruhend',
  'attributes.value.active.yes': 'Aktiv',
  'attributes.value.closed.no': 'Offen',
  'attributes.value.closed.yes': 'Fertig',
  'attributes.value.closed.cancelled': 'Abgebrochen',
  'attributes.value.delivered.no': 'Offen',
  'attributes.value.delivered.yes': 'Fertig oder in Review',
  'attributes.value.verdict.none': 'Offen',
  'attributes.value.verdict.accepted': 'Abgenommen',
  'attributes.value.verdict.disputed': 'Abnahme verweigert',
  'attributes.heading': '{attribute}: {value}',
  'attributes.pair.delivered': 'Fertigstellung: {value}',
  'attributes.pair.closed': 'Abschluss: {value}',
  'attributes.pair.position.done': 'Fertig',
  'attributes.pair.position.cancelled': 'Abgebrochen',
  'attributes.pair.active': 'Aktiv: {value}',
  'attributes.pair.yes': 'ja',
  'attributes.pair.no': 'nein',
  'attributes.pair.verdict.none': 'Bewertung: noch keine',
  'attributes.pair.verdict.accepted': 'Bewertung: Abgenommen',
  'attributes.pair.verdict.disputed': 'Bewertung: Abnahme verweigert',
  'attributes.pair.signal.worn': '{signal}: gesetzt',
  'attributes.pair.signal.clear': '{signal}: aufgehoben',
  'attributes.pair.field': '{field}: {value}',
  'attributes.pair.field.empty': '{field}: leer',
  'attributes.pair.field.other': '{field}: ein anderer Wert',
  'attributes.pair.joined': '{first} · {second}',
} as const satisfies AreaCatalog<typeof en>;
